var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8h12v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M15.75 15.703a2.578 2.578 0 01-3.059 2.533l-.352.396a.35.35 0 01-.262.118h-.547v.586a.35.35 0 01-.351.351h-.586v.586a.352.352 0 01-.352.352h-1.64a.351.351 0 01-.352-.352V19.13c0-.093.037-.183.103-.249l2.37-2.37a2.579 2.579 0 115.027-.808zM13.172 15a.703.703 0 101.407 0 .703.703 0 00-1.407 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#FFD044",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M2.89 5.475l.229-.77h1.155l.24.77h.794l-1.19-3.378h-.804l-1.19 3.378h.766zm1.233-1.297h-.848l.42-1.414.428 1.414zM6.44 5.475V4.242h.58c.35 0 .629-.096.833-.288.205-.192.308-.453.308-.785 0-.331-.103-.593-.308-.785-.204-.192-.482-.287-.833-.287H5.727v3.378h.712zm.497-1.78H6.44V2.644h.497c.162 0 .287.044.373.134.086.09.13.22.13.392 0 .172-.044.303-.13.393-.086.089-.21.134-.373.134zm2.56 1.78V2.097h-.732v3.378h.731z"
  })))));
}

export default SvgFileTypesApi;